import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { App } from './App';
import { SessionBoundary } from './session/SessionBoundary';
import './tokens.css';
import './styles.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('missing #root element in index.html');
}

/**
 * The owner-scoped query cache. Nothing here is persisted: the client keeps it in
 * memory, and the session boundary clears it on logout and on an owner change
 * (IMPLEMENTATION-CONTRACTS §6 — "no localStorage auth or persistent financial query
 * cache", §7). Retries are off so a refusal is reported as it happened rather than
 * retried into a different one.
 *
 * `refetchOnWindowFocus` is off by default and switched on for the session query alone:
 * re-reading the session on focus is how this client notices that the session ended,
 * and a financial query should not refetch behind an expired session.
 */
const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionBoundary>
        <App />
      </SessionBoundary>
    </QueryClientProvider>
  </StrictMode>,
);
